<div style="background-color: #fff;height: auto;padding: 2px 0px;">
    <div *ngIf="!userSubscription" class="modal-header d-flex justify-content-between align-items-center" style="padding: 20px 25px;" [ngStyle]="{'border-bottom': !newCard ? '0' : ''}" >
        <h5 class="modal-title text-center" style="font-weight: bold;font-size: 24px;">{{!newCard ? 'Purchase Subscription' : 'New Card'}}</h5>
        <img style="cursor:pointer;width: 20px;" (click)="closePopup(false)"
            src="assets/images/service-provider/black-cross-2.png" alt="">
    </div>
    <div *ngIf="!newCard && !userSubscription"  class="subscription-color-head">
        {{subscriptionName}}
    </div>
    <form [formGroup]="form">
        <div class="participant-form-row-1 company-detail-form-row {{userSubscription ? 'padding-x-0' :''}}">
            <div class="row form-div-main">
                <div class="col-12">
                    <div class="label {{userSubscription ? 'stripe-logo' :''}}">
                        <span class="popup-text-style">Cardholder Name</span>
                        <img *ngIf="userSubscription" width="50px" height="auto" src="" alt="" srcset="assets/images/account-subscription/stripe-logo.png">
                    </div>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon {{userSubscription ? 'bg-none' :''}}"><img height="20px" src="assets/images/service-provider/user.png"
                                width="20px"></span><input class="p-inputtext p-component {{userSubscription ? 'border-left-0' :''}}" formControlName="cardholderName"
                            placeholder="Enter Cardholder Name" type="text" style="color:#000000">
                    </div>
                    <div *ngIf="f.cardholderName.invalid && formSubmitted">
                    <div class="error-msg"
                        *ngIf="f.cardholderName.errors && f.cardholderName.errors['required']">
                        Cardholder Name is required
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="col-12 participant-form-row-1 {{userSubscription ? 'padding-x-0' :''}}" [style.visibility]="cardCaptureReady ? 'visible' : 'hidden'">
            <div class="label">
                <span class="popup-text-style">Card Details</span>
            </div>
            <div class="stripe-card-box-outer">
                <stripe-card #stripeCard [options]="stripeOptions" (catch)="onStripeError($event)"
                    [(complete)]="cardDetailsFilledOut" [(invalid)]="invalidError" (cardMounted)="cardCaptureReady = 1"
                    (paymentMethodChange)="setStripePaymentMethod($event)" (tokenChange)="setStripeToken($event)"
                    (invalidChange)="onStripeInvalid($event)" (changed)="onStripeChanged($event)"
                    (sourceChange)="setStripeSource($event)"></stripe-card>
            </div>
            <span *ngIf="showCardError && !cardDetailsFilledOut && stripeError" class="error-msg">{{stripeError}}</span>
            <div class="popup-bottom">
                <!-- <span class="font-wt-600 grand-total pr-2 d-block">Amount</span>
                <span class="green-text font-wt-600 t-price pr-2 d-block">${{(amount) / 100}}</span> -->
                <button *ngIf="!hidePaymentButton" type="submit" class="simple-btn sky-blue next-btn h-40 pay-now w-100"
                    (click)="paymentSubmit()">
                    <span *ngIf="!newCard">PAY {{(amount / 100) | currency: 'USD':true:'1.2-2'}}</span>
                    <span *ngIf="newCard">SAVE</span>
                    <img style="cursor: pointer;"src="assets/images/service-provider/tick-white.png" alt="">
                </button>
                <button *ngIf="hidePaymentButton" type="button" class="w-100 simple-btn sky-blue next-btn h-40 pay-now"><img
                        style="background-color: transparent;height: 25px;" src="assets/images/service-provider/loader.svg"
                        onload="SVGInject(this)" /></button>
            </div>
        </div>
    </form>
</div>